import Vue from 'vue'
import Router from 'vue-router'

import Home from '../components/pages/Home.vue';
import Login from '../components/pages/Login.vue';
import FindGame from '../components/pages/FindGame.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/login',
	  meta: {
	    title: '喔小窝'
      }
    },
    {
      path: '/home',
      component: Home,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
		title: '喔小窝'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
	  meta: {
	    title: '喔小窝'
      }
    },
    {
      path: '/findGame',
      name: 'findGame',
      component: FindGame,
	  meta: {
	    title: '喔小窝'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js